import axios from 'axios'

const { REACT_APP_COGNITO_CONFIGURATION_URI } = process.env

export async function getCognitoConfig() {
  try {
    const result = await axios.get(REACT_APP_COGNITO_CONFIGURATION_URI)
    const cognitoEnv = result.data

    return {
      region: cognitoEnv.region,
      userPoolId: cognitoEnv.userPoolId,
      clientId: cognitoEnv.clientId,
      passwordlessClientId: cognitoEnv.passwordlessClientId,
    }
  } catch (err) {
    console.error('Failed to load Cognito configuration', err)
    throw err
  }
}
